
<template lang="html">
  <div class="editor" ref="simpleEditor">
    <div ref="toolbar" class="toolbar">
    </div>
    <div ref="editor" class="text">
    </div>
  </div>
</template>

<script>
Date.prototype.Format = function (fmt) {
  // author: meizz
  var o = {
    "M+": this.getMonth() + 1, // 月份
    "d+": this.getDate(), // 日
    "h+": this.getHours(), // 小时
    "m+": this.getMinutes(), // 分
    "s+": this.getSeconds(), // 秒
    "q+": Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
import E from "wangeditor";
// import $axios from "../../utils/axios";
export default {
  name: "YnEditor",
  data() {
    return {
      // uploadPath,
      editor: null,
      info_: null,
    };
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isClear: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function (value) {
      if (value !== undefined) {
        this.editor.txt.html(this.value);
      }
    },
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.seteditor();
    this.editor.txt.html(this.value);

    this.$refs["simpleEditor"].addEventListener("input", this.inputEvent);
  },

  methods: {
    seteditor() {
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);

      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "image",
        "video",
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "table", // 表格
        "code", // 插入代码
      ];

      // this.editor.customConfig.pasteIgnoreImg = true;
      this.editor.customConfig.pasteFilterStyle = false;
      this.editor.customConfig.onchange = (html) => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
      };
      // this.editor.customConfig.pasteTextHandle = function (pasteStr) {
      //   // 对粘贴的文本进行处理，然后返回处理后的结果
      //   // var str = pasteStr.replace(/&quot;/g,"")
      //   console.log(`past:${pasteStr}`)
      //   return str
      // };
      //   this.editor.customConfig.showLinkImg = false;
      var self = this;
      this.editor.customConfig.customUploadImg = function (
        resultFiles,
        insertImgFn
      ) {
        //调用上传
        let formData = new FormData();

        resultFiles.forEach((x) => {
          formData.append("file", x);
          console.log(`file:${x.name}`);
        });
        formData.append("UploadType", "Files");
        formData.append(
          "businessType",
          "editor/" + new Date().Format("yyyy/MM/dd")
        );
        self
          .$axios({
            url: "/Upload",
            method: "POST",
            data: formData,
          })
          .then((res) => {
            res.data.uploads.files.forEach((x) => {
              insertImgFn(x.o.fullPath);
            });
          });
        // resultFiles 是 input 中选中的文件列表
        // insertImgFn 是获取图片 url 后，插入到编辑器的方法
        // 上传图片，返回结果，将图片插入到编辑器中
      };
      this.editor.customConfig.showLinkVideo = false;
      this.editor.customConfig.customUploadVideo = function (
        resultFiles,
        insertVideoFn
      ) {
        //调用上传
        let formData = new FormData();

        resultFiles.forEach((x) => {
          formData.append("file", x);
          console.log(`file:${x.name}`);
        });
        formData.append("UploadType", "Files");
        formData.append(
          "businessType",
          "editor/" + new Date().Format("yyyy/MM/dd")
        );
        self
          .$axios({
            url: "/Upload",
            method: "POST",
            data: formData,
          })
          .then((res) => {
            res.data.uploads.files.forEach((x) => {
              insertVideoFn(x.o.fullPath);
            });
          });
      };
      // this.editor.customConfig.onchangeTimeout = 500;

      // 创建富文本编辑器
      this.editor.create();
    },
    inputEvent() {
      let html = this.editor.txt.html();
      if (html === "" || html === "<p><br></p>") {
        this.editor.customConfig.onchange();
      }
    },
  },
  beforeDestroy() {
    this.$refs["simpleEditor"].removeEventListener("input", this.inputEvent);
  },
};
</script>

<style lang="css">
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  height: 250px;
  max-height: 350px;
  /* min-height: 500px; */
}
.w-e-toolbar .w-e-menu i {
  font-size: 12px !important;
}
</style>